import { LanguageCode } from '@navio/nsdk';
import { TanstackFormSelect } from 'noddi-ui-web';
import { getLanguagePropertiesFromCountryCode } from '../../../../utils/languages';

type Props = {
  label?: string;
};

const ALL_LANGUAGE_CODES = Object.values(LanguageCode);

const languageOptions = ALL_LANGUAGE_CODES.map((code) => ({
  value: code,
  label: getLanguagePropertiesFromCountryCode(code).name
}));

export const TanstackLanguageCodeSelect = ({ label = 'Language' }: Props) => {
  return <TanstackFormSelect label={label} options={languageOptions} />;
};
